{
  "postTradingFilter": {
    "searchTicker": "Enter ticker",
    "operationType": "Operation Type",
    "selectType": "Select type"
  }
}
